import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, Button } from "antd";
import updateUserAPI from "../../Redux/APIs/usersAPIs/updateUser";
import dayjs from "dayjs";

const EditUserDetailsModal = ({ isOpen, setIsOpen, data, reloadData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && data) {
      form.setFieldsValue({
        firstName: data?.firstName || "",
        lastName: data?.lastName || "",
        email: data?.email || "",
        phone: data?.phone || "",
        dateOfBirth: data?.dateOfBirth ? dayjs(data.dateOfBirth) : null,
      });
    }
  }, [isOpen, data]);

  const handleFinish = (values) => {
    const d = {
      id: data?._id,
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone,
      dateOfBirth: values.dateOfBirth ? values.dateOfBirth.toISOString() : "",
    };
    setLoading(true);
    updateUserAPI(d, () => {
      setLoading(false);
      reloadData();
      setIsOpen(false);
    });
  };

  return (
    <Modal
      title="Edit User"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item name="firstName" label="First Name" rules={[{ required: true }]}>
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]}>
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item name="email" label="Email">
          <Input placeholder="Email" disabled />
        </Form.Item>
        <Form.Item name="phone" label="Phone" rules={[{ required: true }]}>
          <Input placeholder="Phone" />
        </Form.Item>
        <Form.Item name="dateOfBirth" label="Date of Birth" rules={[{ required: true }]}>
          <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Save Changes
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserDetailsModal;
